import React from "react";
import Intercom from "@intercom/messenger-js-sdk";

export default function IntercomComp({ user }) {
  if (!user?.id) {
    Intercom({
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
    });
  } else {
    Intercom({
      app_id: process.env.REACT_APP_INTERCOM_APP_ID,
      user_id: user.id,
      name: `${user?.firstName} ${user?.lastName}`,
      email: user.email,
      created_at: user.createdAt,
      user_hash: user.user_hash,
    });
  }

  return <div></div>;
}
